<template>
    <div class="row my-4">
        <div class="col col-md-4 col-lg-3 ms-md-auto px-sm-3">
            <div class="search">
                <input
                    type="text"
                    class="form-control"
                    placeholder="Palabra Clave o Evento"
                    v-model.lazy="searchTerm"
                />
                <button class="btn btn-primary" aria-label="Buscar">
                    <i class="fa fa-search"></i>
                </button>
            </div>
        </div>
        <div v-if="filtersButton" class="w-auto">
            <button
                type="button"
                @click="$emit('sidebar-toggled')"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRight"
                aria-controls="offcanvasRight"
                aria-label="Filtros"
                class="btn btn-renault-secondary btn-filtros py-0 px-1 px-sm-2 py-sm-1"
            >
                <span class="d-none d-sm-inline">Filtros</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            searchTerm: this.initialSearch,
        };
    },
    props: {
        filtersButton: {
            type: Boolean,
            default: true,
        },
        initialSearch: {
            type: String,
            default: "",
        },
    },
    mounted() {

    },
    emits: ["sidebar-toggled", "text-searched"],
    watch: {
        searchTerm: function (value) {
            this.$emit("text-searched", value);
        },
    },
};
</script>
